import * as types from '../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  user: [],
  error: null,
};

const NewPasswordReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.NEW_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.NEW_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default NewPasswordReducer;
